import { render } from "./Carrusel-Component-2.vue?vue&type=template&id=d756038e&scoped=true"
import script from "./Carrusel-Component-2.vue?vue&type=script&lang=js"
export * from "./Carrusel-Component-2.vue?vue&type=script&lang=js"

import "./Carrusel-Component-2.vue?vue&type=style&index=0&id=d756038e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d756038e"]])

export default __exports__